import React, { useState } from "react";
import { Button, Container, TextField, Typography } from "@mui/material";
import { DivHelperLinks, LoginTextField, Link } from "./styles";
import { HeaderLogin } from "../Styles/Components";
import { useUsuario } from "../../../Hooks/UsuarioHook";
import { SelecionarContaLogin } from "../../../Components/SelecionarContaLogin";
import { Perfil } from "../../App/Perfil/index";
import { Entidades } from "./Entidades";
import { useEntidade } from "../../../Hooks/EntidadeHook";

export const AutoCadastro = () => {
  const { entidades, entidadeFocus } = useEntidade();

  const handleCadastro = () => {
    //cadastrarUsuario(nome, email, senha);
    // Adicione aqui qualquer lógica adicional após o cadastro
  };

  return entidadeFocus.id ? <Perfil /> : <Entidades />;
};
